export const FIRST_PAGE_NUM = 1;
export const SAFE_LIST_PAGE_SIZE = 100;

function toPositiveInt(value: unknown, fallback: number): number {
  const num = Number(value);
  if (!Number.isFinite(num)) return fallback;
  return Math.max(1, Math.floor(num));
}

export function clampPageSize(value: unknown, fallback = SAFE_LIST_PAGE_SIZE): number {
  return Math.min(toPositiveInt(value, fallback), SAFE_LIST_PAGE_SIZE);
}

export function buildSafePageParams<T extends Record<string, unknown>>(params?: T): T & {
  pageNum: number;
  pageSize: number;
} {
  return {
    ...((params ?? {}) as T),
    pageNum: toPositiveInt(params?.pageNum, FIRST_PAGE_NUM),
    pageSize: clampPageSize(params?.pageSize),
  };
}
